import { CategoryId } from 'core/type/Category.types';
import { SubcategoryId, SubcategoryListByCategoryId, SubcategoryParentId } from 'core/type/Subcategory.types';
import { SubcategoryValueFilter } from 'component/page/search/SortAndFilter/CategoryFilter/CategoryFilter.types';
import { TopSubcategory } from 'core/type/BootstrapConfig.types';
import { FilterState } from 'component/common/Filter/Filter.types';
import { FilterCode } from 'gql/autogen/FilterCode';
import { getFilterStateByValue } from 'component/page/search/SortAndFilter/Filter/filter.utils';

export interface TopSubcategoryFilterMap {
    filterInfo: SubcategoryValueFilter;
    bootstrapInfo: TopSubcategory;
}

export const getSubcategoryIdsFromCategoryId = (categoryId: CategoryId, subcategoryValueFilters: SubcategoryValueFilter[]): SubcategoryId[] => {
    const subcategoryIds = SubcategoryListByCategoryId[categoryId] || [];
    const filteredSubcategoryIds = subcategoryIds.filter((subcategoryId) => {
        return subcategoryValueFilters.some((subcategoryValueFilter) => subcategoryValueFilter.id === subcategoryId && subcategoryValueFilter.count > 0);
    });

    return filteredSubcategoryIds;
};

export const getTopSubcategoryFilterMap = (topSubcategories: TopSubcategory[], subcategoryValueFilters: SubcategoryValueFilter[]): TopSubcategoryFilterMap[] => {
    const subcategoryValueFilterMap: Record<string, SubcategoryValueFilter> = subcategoryValueFilters.reduce<Record<string, SubcategoryValueFilter>>((acc, filter) => {
        acc[filter.id as string] = filter;
        return acc;
    }, {});

    return topSubcategories
        .map((topSubcategory) => {
            const subcategoryValueFilter = subcategoryValueFilterMap[topSubcategory.subcategoryId];
            return {
                filterInfo: subcategoryValueFilter,
                bootstrapInfo: topSubcategory,
            } as TopSubcategoryFilterMap;
        })
        .filter((topSubcategoryFilterMap) => topSubcategoryFilterMap.filterInfo?.count > 0 && topSubcategoryFilterMap.bootstrapInfo.activityCount > 0)
        .sort((a, b) => {
            if (a.filterInfo.showAsSelected && !b.filterInfo.showAsSelected) {
                return -1;
            }
            if (!a.filterInfo.showAsSelected && b.filterInfo.showAsSelected) {
                return 1;
            }
            return a.bootstrapInfo.rankInCity - b.bootstrapInfo.rankInCity;
        });
};

export const onSubcategoryFilterChange = (filter: FilterState, subcategoryFilter: SubcategoryValueFilter[], value: SubcategoryId, selected: boolean): FilterState => {
    const parentCategoryId = SubcategoryParentId[value];
    const isParentSelected = !!filter.valueFilterMatrix.find((item) => item.code === FilterCode.Category && item.values.includes(parentCategoryId));
    const otherSubcategoryIds = getSubcategoryIdsFromCategoryId(parentCategoryId, subcategoryFilter).filter((id) => id !== value);
    const isAllOtherSubcategoriesSelected = otherSubcategoryIds.every((id) =>
        filter.valueFilterMatrix.find((item) => item.code === FilterCode.SubCategory && item.values.includes(id)),
    );
    if (selected && isAllOtherSubcategoriesSelected) {
        const state = getFilterStateByValue(FilterCode.SubCategory, otherSubcategoryIds, false, filter);
        return getFilterStateByValue(FilterCode.Category, [parentCategoryId], true, state);
    }
    if (isParentSelected && !selected) {
        const state = getFilterStateByValue(FilterCode.Category, [parentCategoryId], false, filter);
        return getFilterStateByValue(FilterCode.SubCategory, otherSubcategoryIds, true, state);
    }
    return getFilterStateByValue(FilterCode.SubCategory, [value], selected, filter);
};
